import classNames from 'classnames/bind';
import Button, { BUTTON_TYPES } from 'components/Button/Button';
import PropTypes from 'prop-types';
import { THEME_CONSTS } from 'themes/themes';
import styles from './RouterHeaderNavLink.module.css';

const cx = classNames.bind(styles);

/**
 * The `...rest` element gives the inferred props an index signature, and both of
 * React's prop transforms bail out to the declared props verbatim once
 * `string extends keyof P` — so neither the `propTypes` nor the five
 * `defaultProps` below reach a call site, which leaves `className`, `selected`
 * and `theme` required at every one of them. Declaring the props here restores
 * that optionality; the members are `propTypes` plus what the rest element
 * forwards to `Button`.
 *
 * @param {{
 *   className?: string,
 *   selected?: boolean,
 *   label?: string,
 *   theme?: string,
 *   to?: string,
 *   buttonClassName?: string,
 *   onClick?: (...args: any[]) => void,
 * }} props
 */
export function RouterHeaderNavLink({
  className,
  selected,
  label,
  theme,
  ...rest
}) {
  return (
    <li className={cx('header-nav-link', theme, className, { selected })}>
      <Button
        className={cx('headerLink')}
        buttonType={BUTTON_TYPES.NOSTYLE}
        {...rest}
      >
        {label}
      </Button>
    </li>
  );
}

RouterHeaderNavLink.propTypes = {
  to: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  selected: PropTypes.bool,
  theme: PropTypes.string,
};

RouterHeaderNavLink.defaultProps = {
  to: '',
  label: '',
  className: '',
  theme: THEME_CONSTS.DEFAULT,
  selected: false,
};

export default RouterHeaderNavLink;
